module.exports = __webpack_public_path__ + "static/media/raigad-2.3d52ba77.jpg";